import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { for: "documentClassId" }
const _hoisted_4 = { class: "p-field p-col-6" }
const _hoisted_5 = { for: "company" }
const _hoisted_6 = { class: "p-field p-col-6" }
const _hoisted_7 = { for: "creditor" }
const _hoisted_8 = { class: "p-field p-col-6" }
const _hoisted_9 = { for: "fieldName" }
const _hoisted_10 = {
  key: 0,
  class: "field-option-description"
}
const _hoisted_11 = {
  key: 2,
  class: "p-error"
}
const _hoisted_12 = { class: "p-field p-col-6" }
const _hoisted_13 = { for: "dataType" }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = { class: "p-field p-col-12" }
const _hoisted_16 = { for: "prompt" }
const _hoisted_17 = {
  key: 0,
  class: "p-error"
}
const _hoisted_18 = { class: "p-field-checkbox p-col-12" }
const _hoisted_19 = { for: "active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.XmlMapper.DocumentClass')), 1),
      _createVNode(_component_Dropdown, {
        id: "documentClassId",
        modelValue: _ctx.value.documentClassId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.documentClassId) = $event)),
        options: _ctx.documentClassOptions,
        optionValue: "id",
        optionLabel: "label",
        filter: true,
        autoFilterFocus: true,
        showClear: true,
        placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
        onChange: _ctx.onChangeClass,
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "placeholder", "onChange", "onShow"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.XmlMapper.Company')), 1),
      (_ctx.companyOptions.length)
        ? (_openBlock(), _createBlock(_component_Dropdown, {
            key: 0,
            id: "company",
            modelValue: _ctx.value.company,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.company) = $event)),
            options: _ctx.companyOptions,
            optionValue: "id",
            optionLabel: "label",
            filter: true,
            autoFilterFocus: true,
            showClear: true,
            placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
            onChange: _ctx.onChangeCompany,
            onShow: _ctx.showDropdownOverlay
          }, null, 8, ["modelValue", "options", "placeholder", "onChange", "onShow"]))
        : (_openBlock(), _createBlock(_component_InputText, {
            key: 1,
            id: "company",
            modelValue: _ctx.value.company,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.company) = $event)),
            modelModifiers: { trim: true },
            placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
            onInput: _ctx.onChangeInput
          }, null, 8, ["modelValue", "placeholder", "onInput"]))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('Squeeze.Prompts.Creditor')), 1),
      (_ctx.creditorOptions.length)
        ? (_openBlock(), _createBlock(_component_Dropdown, {
            key: 0,
            id: "creditor",
            modelValue: _ctx.value.creditor,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.creditor) = $event)),
            options: _ctx.filteredCreditorOptions,
            optionValue: "id",
            optionLabel: "label",
            filter: true,
            autoFilterFocus: true,
            showClear: true,
            placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
            onChange: _ctx.onChangeInput,
            onShow: _ctx.showDropdownOverlay
          }, null, 8, ["modelValue", "options", "placeholder", "onChange", "onShow"]))
        : (_openBlock(), _createBlock(_component_InputText, {
            key: 1,
            id: "creditor",
            modelValue: _ctx.value.creditor,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value.creditor) = $event)),
            modelModifiers: { trim: true },
            placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
            onInput: _ctx.onChangeInput
          }, null, 8, ["modelValue", "placeholder", "onInput"]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('Squeeze.XmlMapper.FieldName')) + " *", 1),
      (_ctx.readonlyFieldName)
        ? (_openBlock(), _createBlock(_component_InputText, {
            key: 0,
            id: "fieldName",
            modelValue: _ctx.value.fieldName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value.fieldName) = $event)),
            disabled: true
          }, null, 8, ["modelValue"]))
        : (_openBlock(), _createBlock(_component_Dropdown, {
            key: 1,
            id: "fieldName",
            modelValue: _ctx.v$.fieldName.$model,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.fieldName.$model) = $event)),
            options: _ctx.fields,
            optionValue: "name",
            optionLabel: "name",
            filter: true,
            filterFields: ['name', 'translatedDescription', 'description'],
            autoFilterFocus: true,
            showClear: true,
            class: _normalizeClass({'p-invalid': _ctx.v$.fieldName.$invalid && _ctx.showErrorMessage}),
            onChange: _ctx.onChangeFieldName,
            onShow: _ctx.showDropdownOverlay
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(slotProps.option.name), 1),
                (_ctx.getTranslatedDescription(slotProps.option))
                  ? (_openBlock(), _createElementBlock("small", _hoisted_10, " – " + _toDisplayString(_ctx.getTranslatedDescription(slotProps.option)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "class", "onChange", "onShow"])),
      (!_ctx.readonlyFieldName && _ctx.v$.fieldName.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.XmlMapper.FieldName') })), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('Squeeze.MasterData.FileType')) + " *", 1),
      _createVNode(_component_Dropdown, {
        id: "dataType",
        modelValue: _ctx.v$.dataType.$model,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.dataType.$model) = $event)),
        options: _ctx.dataTypes,
        optionValue: "id",
        optionLabel: "text",
        class: _normalizeClass({'p-invalid': _ctx.v$.dataType.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.onChangeInput,
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "class", "onChange", "onShow"]),
      (_ctx.v$.dataType.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.MasterData.FileType') })), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('Squeeze.Prompts.Prompt')) + " *", 1),
      _createVNode(_component_Textarea, {
        id: "prompt",
        modelValue: _ctx.v$.prompt.$model,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.prompt.$model) = $event)),
        modelModifiers: { trim: true },
        autoResize: true,
        rows: "6",
        class: _normalizeClass({'p-invalid': _ctx.v$.prompt.$invalid && _ctx.showErrorMessage}),
        onInput: _ctx.onChangeInput
      }, null, 8, ["modelValue", "class", "onInput"]),
      (_ctx.v$.prompt.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Prompts.Prompt') })), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_Checkbox, {
        id: "active",
        modelValue: _ctx.value.active,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.value.active) = $event)),
        binary: true,
        onChange: _ctx.onChangeInput
      }, null, 8, ["modelValue", "onChange"]),
      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('Squeeze.System.Active')), 1)
    ])
  ]))
}